import { render, staticRenderFns } from "./addLoginType.vue?vue&type=template&id=273d7b94&"
import script from "./addLoginType.vue?vue&type=script&lang=js&"
export * from "./addLoginType.vue?vue&type=script&lang=js&"
import style0 from "./addLoginType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273d7b94')) {
      api.createRecord('273d7b94', component.options)
    } else {
      api.reload('273d7b94', component.options)
    }
    module.hot.accept("./addLoginType.vue?vue&type=template&id=273d7b94&", function () {
      api.rerender('273d7b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/components/addLoginType.vue"
export default component.exports